import { createFileRoute } from "@tanstack/react-router";
import OneDayTmsPage from "@/pages/OneDayTmsPage";
export const Route = createFileRoute("/ampa")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Ampa One™ TMS in Florida | Camera-Guided, Accelerated Depression Treatment | Coral Springs",
        },
        {
          name: "description",
          content:
            "Ampa One™ is FDA-cleared, camera-guided TMS for depression that hasn't improved with medication. Accelerated schedules in Coral Springs, FL. Free consultation: 954-827-9793.",
        },
        {
          property: "og:title",
          content:
            "Ampa One™ TMS in Florida | Camera-Guided, Accelerated Depression Treatment",
        },
        {
          property: "og:description",
          content:
            "Ampa One™ is FDA-cleared, camera-guided TMS for depression that hasn't improved with medication. Accelerated schedules in Coral Springs, FL. Free consultation: 954-827-9793.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/ampa",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/ampa",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <OneDayTmsPage />;
}
